/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import {
  Tab,
  Tabs,
  TabList,
  TabPanel,
} from 'react-tabs';
import { graphql } from 'react-apollo';
import { faq } from '../../queries';

import Faq from './Faq';
import Form from './Form';
import Loading from '../../components/Loading/Page';
import Footer from '../../components/Footer';

import { Menu, Content } from './styles';
import { Breadcrumb, Wrapper } from '../../assets/styles';

class Help extends Component {
  state = {
    selected: new Map(),
  }

  onPressItem = (id) => {
    this.setState((state) => {
      const selected = new Map(state.selected);
      selected.set(id, !selected.get(id));
      return { selected };
    });
  };

  render() {
    const { loading, faqPortal } = this.props.data;

    return (
      <div style={{ position: 'absolute', width: '100%' }}>
        <MetaTags>
          <title>Central de ajuda - Portal da Loja - Reforma Fácil</title>
          <meta name="robots" content="noindex" />
        </MetaTags>
        <Breadcrumb>
          <div className="container">
            <h2>Central de ajuda</h2>
          </div>
        </Breadcrumb>
        <Wrapper>
          <Tabs defaultIndex={0}>
            <TabList style={{ margin: 0, padding: 0 }}>
              <Menu>
                <Tab className="container">
                  <h2>Perguntas & Respostas</h2>
                  <p>Caso tenha dúvidas separamos algumas perguntas para te ajudar.</p>
                </Tab>
                <Tab className="container">
                  <h2>Enviar mensagem</h2>
                  <p>Ainda precisa de ajuda? Envie uma mensagem para o nosso time de atendimento.</p>
                </Tab>
                <div style={{ flex: 1 }} />
              </Menu>
            </TabList>
            <TabPanel style={{ marginTop: '30px' }}>
              {loading && <Loading size={8} margin="1px" />}
              {!loading && (
                <Content>
                  <h2 className="category">Conta</h2>
                  {faqPortal.account.map(item => (
                    <Faq
                      key={item._id}
                      id={item._id}
                      item={item}
                      onPressItem={this.onPressItem}
                      selected={!!this.state.selected.get(item._id)}
                    />
                  ))}
                  <h2 className="category">Materiais</h2>
                  {faqPortal.product.map(item => (
                    <Faq
                      key={item._id}
                      id={item._id}
                      item={item}
                      onPressItem={this.onPressItem}
                      selected={!!this.state.selected.get(item._id)}
                    />
                  ))}
                  <h2 className="category">Pedidos</h2>
                  {faqPortal.order.map(item => (
                    <Faq
                      key={item._id}
                      id={item._id}
                      item={item}
                      onPressItem={this.onPressItem}
                      selected={!!this.state.selected.get(item._id)}
                    />
                  ))}
                  <h2 className="category">Pagamentos</h2>
                  {faqPortal.payment.map(item => (
                    <Faq
                      key={item._id}
                      id={item._id}
                      item={item}
                      onPressItem={this.onPressItem}
                      selected={!!this.state.selected.get(item._id)}
                    />
                  ))}
                </Content>
              )}
            </TabPanel>
            <TabPanel>
              <Form />
            </TabPanel>
          </Tabs>
          <Footer />
        </Wrapper>
      </div>
    );
  }
}

export default graphql(faq, {
  options: () => ({
    fetchPolicy: 'network-only',
  }),
})(Help);
